"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StaffMemberDto = void 0;
const LocationDto_1 = require("../locations/LocationDto");
class StaffMemberDto {
    constructor(params) {
        this.department = "";
        this.firstName = "";
        this.lastName = "";
        this.title = "";
        this.email = "";
        this.phone = "";
        this.textMessageNumber = "";
        this.createdAt = "";
        this.updatedAt = "";
        if (!params) {
            return;
        }
        this.id = params.id;
        this.locationId = params.locationId;
        this.imageId = params.imageId;
        this.imagePath = params.imagePath;
        this.department = params.department;
        this.firstName = params.firstName;
        this.lastName = params.lastName;
        this.title = params.title;
        this.email = params.email;
        this.phone = params.phone;
        this.textMessageNumber = params.textMessageNumber;
        this.order = params.order;
        this.createdAt = params.createdAt;
        this.updatedAt = params.updatedAt;
        this.isDeleted = params.isDeleted;
        this.isActive = params.isActive;
        if (params.location !== undefined) {
            this.location = params.location === null ?
                null :
                new LocationDto_1.LocationDto(params.location);
        }
    }
}
exports.StaffMemberDto = StaffMemberDto;
//# sourceMappingURL=StaffMemberDto.js.map